module.exports = __webpack_public_path__ + "img/12.a7f47fb9.png";